(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('pendingPayments', pendingPayments);

    function pendingPayments(lodash) {
        return {
            retrict: 'E',
            scope: {
                options: '=?',
                getModel: '=',
            },
            templateUrl: 'common/app/components/billing/pending-payments',
            controller: pendingPaymentsCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, iElement, iAttrs, ngModelCtrl) {

            },
        };

        function pendingPaymentsCtrl($scope, GenericModel) {
            var vm = this;

            // functions
            this.$onInit = function() {
                vm.getSelectedPendingPaymentsEntity = getSelectedPendingPaymentsEntity;
                vm.setSelectedPendingPaymentsEntity = setSelectedPendingPaymentsEntity;
                vm.addPendingPaymentsForPurchaseOrder = addPendingPaymentsForPurchaseOrder;
                vm.removePendingPaymentsForPurchaseOrder = removePendingPaymentsForPurchaseOrder;
                vm.hasPendingPaymentsForPurchaseOrder = hasPendingPaymentsForPurchaseOrder;
                vm.getTotalPendingPaymentsForPurchaseOrder = getTotalPendingPaymentsForPurchaseOrder;
                vm.getCurrency = getCurrency;
                vm.getModel = getModel;

                // init
                vm.selectedPendingPaymentsEntity = null;
                vm.pendingPaymentsForPurchaseOrder = [];

                init();
            }

            function init() {
                // callRemoteApi(lodash.get(vm, 'options.datasource.pending_payments_entities', {}))
                //     .then(function (res) {
                //         vm.pendingPaymentEntities = res || [];
                //         setSelectedPendingPaymentsEntity(lodash.get(lodash.head(vm.pendingPaymentEntities), 'entity', null));
                //     });

                // $scope.$watch('vm.selectedPendingPaymentsEntity', function () {
                //     resetPendingPaymentsForPurchaseOrder();
                    callRemoteApi(lodash.get(vm, 'options.datasource.pending_payments_entity', {}))
                        .then(function (res) {
                            vm.pendingPaymentEntity = res.rows || [];
                        });
                // });

                $scope.$watch('vm.pendingPaymentsForPurchaseOrder', function () {
                    lodash.set(vm, 'options.submit_button.attr.disabled', vm.pendingPaymentsForPurchaseOrder.length === 0);
                })
            }

            function setSelectedPendingPaymentsEntity(pendingPaymentsEntity) {
                vm.selectedPendingPaymentsEntity = pendingPaymentsEntity;
            }
            
            function getSelectedPendingPaymentsEntity() {
                var foundSelectedPendingPaymentsEntity = lodash.find(vm.pendingPaymentEntities, { entity: vm.selectedPendingPaymentsEntity });
                return foundSelectedPendingPaymentsEntity;
            }

            function resetPendingPaymentsForPurchaseOrder() {
                vm.pendingPaymentsForPurchaseOrder = [];
            }

            function addPendingPaymentsForPurchaseOrder(pendingPayment) {
                vm.pendingPaymentsForPurchaseOrder = vm.pendingPaymentsForPurchaseOrder.concat([ pendingPayment ]);
            }

            function removePendingPaymentsForPurchaseOrder(pendingPayment) {
                var foundIndex = lodash.findIndex(vm.pendingPaymentsForPurchaseOrder, { id: pendingPayment.id });

                if (foundIndex >= 0) {
                    vm.pendingPaymentsForPurchaseOrder = vm.pendingPaymentsForPurchaseOrder
                        .slice(0, foundIndex)
                        .concat(vm.pendingPaymentsForPurchaseOrder.slice(foundIndex + 1));
                }
            }

            function hasPendingPaymentsForPurchaseOrder(pendingPayment) {
                var foundIndex = lodash.findIndex(vm.pendingPaymentsForPurchaseOrder, { id: pendingPayment.id });

                if (foundIndex >= 0) return true;
                return false;
            }
            
            function getTotalPendingPaymentsForPurchaseOrder() {
                return lodash.reduce(vm.pendingPaymentsForPurchaseOrder, function (sum, oPendingPaymentsForPurchaseOrder) {
                    return lodash.get(oPendingPaymentsForPurchaseOrder, 'amount', 0) + sum;
                }, 0);
            }

            function getCurrency() {
                return lodash.get(lodash.head(vm.pendingPaymentEntity), 'currency', null);
            }

            function getModel() {
                return lodash.map(vm.pendingPaymentsForPurchaseOrder, function (pendingPaymentForPurchaseOrder) {
                    return { id: lodash.get(pendingPaymentForPurchaseOrder, 'id') };
                });
            }

            function callRemoteApi(datasource, postData) {
                var model = new GenericModel(datasource.url);
                var method = lodash.get(datasource, 'method', 'get');

                var queries = postData;
                var params = {};

                if (method !== 'get') {
                    queries = {};
                    params = {
                        data: postData,
                    }
                }

                return model[method](queries, params).$promise.then(function(res) { //res
                    if (res.success && res.status_code == 200) {

                        return res;
                    } else {
                        console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                        return null;
                    }
                }, function(err) {
                    console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    console.warn(err); // eslint-disable-line no-console
                    return null;
                });
            }
        }
    }
})();